export const justificationForTextPosition = {
  left: "flex-start",
  right: "flex-end",
};
